import { Box, CircularProgress } from "@mui/material";

const CustomCircularProgress = () => {
  return (
    <Box sx={{height:"70vh"}}>
        <CircularProgress 
            color="primary"
            sx={{position: 'absolute'}}
        />
    </Box>
  );
};

export default CustomCircularProgress;